module.exports = __webpack_public_path__ + "img/poplar.70eccb3.svg";